























































































import { Component, Vue } from 'vue-property-decorator'
import ApiClient from '@/services/api-client'
import { PrepArea, PrepTask } from '@/models'
import { newPrepTask, removePrepItem, savePrepItem, showPrepError, showPrepModal } from '@/utils/production-prep'
import UpsertPrepAreaModal from '@/components/modals/UpsertPrepAreaModal.vue'
import UpsertPrepTaskModal from '@/components/modals/UpsertPrepTaskModal.vue'
import PrepAreaCard from '@/components/productionPrep/PrepAreaCard.vue'
import PrepTaskBadges from '@/components/productionPrep/PrepTaskBadges.vue'

/** Catalog of areas and tasks copied by every new production preparation */
@Component({
  components: { UpsertPrepAreaModal, UpsertPrepTaskModal, PrepAreaCard, PrepTaskBadges }
})
export default class PrepCatalog extends Vue {
  private areas: PrepArea[] = []
  private loading = false
  private selectedArea: PrepArea | null = null
  private selectedTask: PrepTask | null = null
  private closedAreas: number[] = []

  get taskCount(): number {
    return this.areas.reduce((total, area) => total + area.tasks.length, 0)
  }

  get optionalCount(): number {
    return this.areas.reduce((total, area) => total + area.tasks.filter(task => !task.required).length, 0)
  }

  toggleArea(area: PrepArea) {
    const index = this.closedAreas.indexOf(area.id)
    if (index >= 0) this.closedAreas.splice(index, 1)
    else this.closedAreas.push(area.id)
  }

  async created() {
    await this.loadCatalog()
  }

  async loadCatalog() {
    try {
      this.loading = true
      this.areas = await ApiClient.getPrepCatalog()
    } catch (error) {
      showPrepError(this, error)
    } finally {
      this.loading = false
    }
  }

  openAreaModal(area: PrepArea | null) {
    this.selectedArea = area
    showPrepModal(this, 'UpsertPrepAreaModal')
  }

  openTaskModal(task: PrepTask | null, areaId: number) {
    this.selectedTask = task || newPrepTask(areaId)
    showPrepModal(this, 'UpsertPrepTaskModal')
  }

  saveArea(area: PrepArea, done: (saved: boolean) => void) {
    return savePrepItem(this, () => ApiClient.savePrepArea(area), done, this.loadCatalog)
  }

  saveTask(task: PrepTask, done: (saved: boolean) => void) {
    return savePrepItem(this, () => ApiClient.savePrepTask(task), done, this.loadCatalog)
  }

  confirmDeleteArea(area: PrepArea) {
    const message = this.$t('production_prep.catalog.confirm_delete_area', { name: area.name }).toString()
    return removePrepItem(this, message, () => ApiClient.deletePrepArea(area.id), this.loadCatalog)
  }

  confirmDeleteTask(task: PrepTask) {
    const message = this.$t('production_prep.catalog.confirm_delete_task', { name: task.name }).toString()
    return removePrepItem(this, message, () => ApiClient.deletePrepTask(task.id), this.loadCatalog)
  }
}
